import { ContentItem, ContentItemLinks } from "./utils/DataModel"

export function Card(props: ContentItem): JSX.Element {
    return (
        <div className="max-w-4xl h-1/3 rounded-md flex flex-col md:flex-row justify-between mx-auto my-10 p-10 transform-gpu motion-safe:transition motion-safe:duration-200 motion-safe:ease-in-out motion-safe:hover:-translate-y-1 motion-safe:hover:scale-103 motion-safe:focus:-translate-y-1 motion-safe:focus:scale-103" tabIndex={0}>
            <img
                src={props.img.path}
                alt={props.img.title}
                className="w-1/4 md:w-1/6 self-center pb-4 md:pb-0"
                loading='lazy'
            />
            <div className="w-5/6 md:pl-10 text-center self-center md:text-left space-y-5">
                <h3><strong className="self-center">{props.description.title}</strong></h3>
                <p className="text-left opacity-90">
                    {props.description.description}
                </p>
                <div>
                    {props.links?.map(link => (
                        <CardLink key={link.url} title={link.title} url={link.url} />
                    ))}
                </div>
            </div>
        </div>
    )
}

function CardLink(props: ContentItemLinks): JSX.Element {
    return (
        <a href={props.url} target="_blank" rel="noreferrer noopener" className="rounded-full px-2 py-1 text-xs mr-2 bg-primary text-light">
            {props.title}
        </a>
    )
}
